/* ======================================================================================================================
   SWB v2 - THE SHORTLIST
   NEW FILE. A heart on every product card and product page, a counter in the header, and a page that turns the list
   into a cart. Loaded store-wide by sections/swb-header-v2.liquid.

   STORAGE: localStorage `swbShortlist` = [{h: handle, t: added-at}], newest last, max 50. Other tabs follow through
   the `storage` event. The chat assistant's own session shortlist (6 handles, sessionStorage) is imported once, so a
   heart given in the chat is not lost the moment the customer leaves it.
   ====================================================================================================================== */
(function () {
  if (window.swbShortlist) return;
  var KEY = 'swbShortlist';
  var MAX = 50;
  var EVT = 'swb-v2:shortlist';
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/i;
  var lang = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = {
    nl: { add: 'Bewaar in je lijst', rm: 'Verwijder uit je lijst', saved: 'Bewaard' },
    de: { add: 'Auf deine Liste', rm: 'Von deiner Liste entfernen', saved: 'Gemerkt' },
    fr: { add: 'Ajouter à votre liste', rm: 'Retirer de votre liste', saved: 'Enregistré' },
    es: { add: 'Guardar en tu lista', rm: 'Quitar de tu lista', saved: 'Guardado' },
    en: { add: 'Save to your list', rm: 'Remove from your list', saved: 'Saved' }
  }[lang] || null;
  if (!T) T = { add: 'Save to your list', rm: 'Remove from your list', saved: 'Saved' };

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return x && HANDLE_RE.test(x.h); }) : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(-MAX))); } catch (e) { /* private mode */ }
    document.dispatchEvent(new CustomEvent(EVT, { detail: list }));
  }
  function has(h) { return read().some(function (x) { return x.h === h; }); }
  function toggle(h) {
    if (!HANDLE_RE.test(h)) return false;
    var list = read();
    var at = -1;
    list.forEach(function (x, i) { if (x.h === h) at = i; });
    if (at > -1) list.splice(at, 1);
    else list.push({ h: h, t: Date.now() });
    write(list);
    itemEvent(h, at < 0);
    return at < 0;
  }
  function remove(h) {
    var was = has(h);
    write(read().filter(function (x) { return x.h !== h; }));
    if (was) itemEvent(h, false);
  }
  /* ONE HEART, ONE NOTICE (2026-10-19): the list itself only knows "the list changed"; whoever needs to know WHICH strap
     went in or out (the Klaviyo link at the bottom of this file) listens here. The chat import adds in bulk and is not
     a heart, so it says nothing. */
  var ITEM_EVT = 'swb-v2:shortlist-item';
  function itemEvent(h, on) {
    try { document.dispatchEvent(new CustomEvent(ITEM_EVT, { detail: { handle: h, on: on, count: read().length } })); } catch (e) { /* old browser */ }
  }

  // one-time import of the assistant's session list
  (function importChat() {
    try {
      if (localStorage.getItem(KEY + ':chatImported')) return;
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        var raw = sessionStorage.getItem(k) || '';
        if (raw.indexOf('"list"') < 0) continue;
        var st = JSON.parse(raw);
        if (st && Array.isArray(st.list) && st.list.length) {
          var list = read();
          st.list.forEach(function (h) {
            if (HANDLE_RE.test(h) && !list.some(function (x) { return x.h === h; })) list.push({ h: h, t: Date.now() });
          });
          write(list);
          localStorage.setItem(KEY + ':chatImported', '1');
          return;
        }
      }
    } catch (e) { /* ignore */ }
  })();

  var HEART = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3l-1.3-1.2C5.9 14.8 3 12.1 3 8.8 3 6.1 5.1 4 7.8 4c1.6 0 3.1.8 4.2 2 1.1-1.2 2.6-2 4.2-2C18.9 4 21 6.1 21 8.8c0 3.3-2.9 6-7.7 10.3z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';

  function handleOf(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function paint(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? T.rm : T.add);
    btn.classList.toggle('is-on', on);
  }
  /* SAVED, SAID OUT LOUD (2026-10-15, asked): a heart that turns on shows the same notice as the quick add, with the
     strap's photo and a way to the list */
  var SAVED_T = { nl: ['Bewaard in je lijst', 'Bekijk'], de: ['In deiner Liste gespeichert', 'Ansehen'], fr: ['Enregistré dans votre liste', 'Voir'], es: ['Guardado en tu lista', 'Ver'], en: ['Saved to your list', 'View list'] };
  function savedToast(b) {
    if (!window.swbV2Toast) return;
    var t = SAVED_T[String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || SAVED_T.en;
    var card = b.closest('.product-card');
    var title = '', img = '';
    if (card) {
      var tt = card.querySelector('.product-card__title'); title = tt ? tt.textContent.trim() : '';
      var ci = card.querySelector('.product-card__image--primary, img'); img = ci ? (ci.currentSrc || ci.src) : '';
    } else {
      var h1 = document.querySelector('.product-info__title, .upp__title, main h1'); title = h1 ? h1.textContent.trim() : '';
      var pi = document.querySelector('.upp__stage-img, .product-gallery__media.is-selected img, .product-gallery__media img'); img = pi ? (pi.currentSrc || pi.src) : '';
    }
    if (img) img = img.replace(/([?&])width=\d+/, '$1width=120');
    var link = document.querySelector('a[href*="shortlist"]');
    window.swbV2Toast(title, img ? img.split('&width=')[0].split('?width=')[0] : '', { msg: t[0], go: t[1], href: link ? link.getAttribute('href') : '/pages/shortlist' });
  }
  function makeHeart(h, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'v2-heart ' + (cls || '');
    b.setAttribute('data-v2-heart', h);
    b.innerHTML = HEART;
    paint(b, has(h));
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var on = toggle(h);
      b.classList.remove('is-pop');
      void b.offsetWidth;
      if (on) { b.classList.add('is-pop'); savedToast(b); }
    });
    return b;
  }

  /* HEARTS ON CARDS: every theme product card, wherever it is (rows are re-fetched, so the DOM is watched) */
  /* ONE CARD, EVERY PAGE (2026-10-05): some sections print prices with the currency code ("£37.99 GBP"), others
     without; on a compact card the code wrapped the compare-at price onto a second line. Every card drops it. */
  var CODE = /\s*(GBP|EUR|USD|CHF)\s*$/;
  function cleanPrices(root) {
    (root || document).querySelectorAll('.product-card sale-price:not([data-v2-p]), .product-card compare-at-price:not([data-v2-p])').forEach(function (el) {
      el.setAttribute('data-v2-p', '');
      for (var n = el.lastChild; n; n = n.previousSibling) {
        if (n.nodeType === 3 && n.nodeValue.trim()) {
          if (CODE.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(CODE, '');
          break;
        }
      }
    });
  }
  function decorate(root) {
    // hearts on every product card, the live collection grids too (2026-10-14, asked); the title clean-up only
    // where the cards wear the new look (the homepage), so live cards stay exactly live
    if (document.documentElement.classList.contains('v2-home')) cleanPrices(root);
    (root || document).querySelectorAll('.product-card:not([data-v2-hearted])').forEach(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      var h = a && handleOf(a.getAttribute('href'));
      if (!h) return;
      card.setAttribute('data-v2-hearted', '');
      var fig = card.querySelector('.product-card__figure') || card;
      /* The theme's figure is already position:relative, and swb-v2.css backs that up with a zero-specificity rule.
         Reading getComputedStyle here per card, right after the previous card was written to, forced a style pass
         per card: 811ms on the 96-card selection page. Only the rare card without a figure is checked. */
      if (fig === card && getComputedStyle(fig).position === 'static') fig.style.position = 'relative';
      fig.appendChild(makeHeart(h, 'v2-heart--card'));
      // the badges move into the image, so they are placed against the picture rather than the whole card
      var bl = card.querySelector('.product-card__badge-list');
      if (bl && fig !== card && !fig.contains(bl)) fig.appendChild(bl);
    });
    // the product page: next to the title
    /* one heart per title: the v2 product page has a phone title and a desktop title, and only placing a heart by the
       first (the phone one, hidden from 1000px) left desktop without one (fixed 2026-10-04) */
    var ph = /\/products\//.test(location.pathname) && handleOf(location.pathname);
    /* ON THE PHOTO (2026-10-14, asked: the heart between the title and the price looked misplaced). A round heart in
       the top-right corner of the product photos, under the phone zoom button, like on the cards. The pill by the title
       stays only where a page has no theme gallery. */
    var gal = ph && document.querySelector('.product-gallery__media-list-wrapper');
    if (gal) {
      if (!gal.querySelector('.v2-heart--pdpimg')) {
        if (getComputedStyle(gal).position === 'static') gal.style.position = 'relative';
        var gb = makeHeart(ph, 'v2-heart--pdpimg');
        gb.setAttribute('aria-label', T.add);
        document.addEventListener(EVT, function () { gb.setAttribute('aria-label', has(ph) ? T.saved : T.add); });
        gal.appendChild(gb);
      }
      return;
    }
    var titles = ph ? document.querySelectorAll('.product-info__title') : [];
    if (ph && !titles.length) titles = [document.querySelector('.product-title, main h1')].filter(Boolean);
    Array.prototype.forEach.call(titles, function (title) {
      var nx = title.nextElementSibling;
      if (nx && nx.classList.contains('v2-heart--pdp')) return;
      var wrap = title.parentElement;
      var b = makeHeart(ph, 'v2-heart--pdp');
      // the heart shows and hides with its own title (the desktop title is hide-mobile, the phone one is not)
      Array.prototype.forEach.call(title.classList, function (c) { if (/hide|hidden/.test(c)) b.classList.add(c); });
      b.insertAdjacentHTML('beforeend', '<span class="v2-heart__txt"></span>');
      var txt = b.querySelector('.v2-heart__txt');
      var sync = function () { txt.textContent = has(ph) ? T.saved : T.add; };
      sync();
      document.addEventListener(EVT, sync);
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      title.insertAdjacentElement('afterend', b);
    });
  }
  /* PHOTOS ON A CARD, FOR A THUMB. The theme's card carousel and our homepage swap both work with two arrows, which on
     a phone sit on every picture next to the heart, the cart and the badges. On a touch screen the arrows go; a small
     row of dots says how many photos there are and a tap on it shows the next, and on a page that scrolls down (not
     inside a sideways row, where the swipe belongs to the row) a sideways swipe on the picture does the same. */
  var NEXT = { nl: 'Volgende foto', de: 'N\u00e4chstes Foto', fr: 'Photo suivante', es: 'Foto siguiente' }[lang] || 'Next photo';
  var PREV = { nl: 'Vorige foto', de: 'Vorheriges Foto', fr: 'Photo pr\u00e9c\u00e9dente', es: 'Foto anterior' }[lang] || 'Previous photo';
  var touch = window.matchMedia('(hover: none)');
  /* Is this card inside a sideways-scrolling row? Every card in a row shares its ancestors, so each ancestor is
     judged once per pass (the cache) instead of once per card, and gallery() asks for all cards before it writes
     anything, so the whole pass costs one layout rather than one per card (925ms on the selection page). */
  function inRow(el, cache) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var hit = cache && cache.get(p);
      if (hit === undefined) {
        var ox = getComputedStyle(p).overflowX;
        hit = (ox === 'auto' || ox === 'scroll') && p.scrollWidth > p.clientWidth + 4;
        if (cache) cache.set(p, hit);
      }
      if (hit) return true;
    }
    return false;
  }
  /* PHOTO ARROWS ON EVERY CARD OFF THE HOMEPAGE (2026-10-14, asked): the live cards keep their own dots; where their
     carousel has more than one photo, our two side arrows flip it (the theme's own arrows only show on hover) */
  function cardArrows(root, only) {
    (root || document).querySelectorAll(only || '.product-card:not([data-v2-arr]):not([data-v2-gal])').forEach(function (card) {
      card.setAttribute('data-v2-arr', '');
      var car = card.querySelector('product-card-carousel');
      // cards with one front photo + one hover photo (bestsellers, rows): the arrows flip between the two (2026-10-14)
      var sec = !car && card.querySelector('.product-card__image--secondary');
      if (!sec && (!car || car.querySelectorAll('.product-card__carousel-slide').length < 2)) return;
      var fig = card.querySelector('.product-card__figure') || (car || sec).parentElement;
      if (getComputedStyle(fig).position === 'static') fig.style.position = 'relative';
      [-1, 1].forEach(function (d) {
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'v2-garr v2-garr--' + (d < 0 ? 'p' : 'n');
        a.setAttribute('aria-label', d < 0 ? PREV : NEXT);
        a.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        a.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          if (sec) { card.classList.toggle('v2-alt'); return; }
          var b = car.querySelector(d > 0 ? '[data-carousel-next], .product-card__carousel-next, button[is=next-button]' : '[data-carousel-prev], .product-card__carousel-prev, button[is=prev-button]');
          if (b) { b.click(); return; }
          var sl = car.querySelectorAll('.product-card__carousel-slide'), at = 0;
          for (var i = 0; i < sl.length; i++) if (sl[i].classList.contains('is-active') || sl[i].classList.contains('is-selected')) at = i;
          var to = (at + d + sl.length) % sl.length;
          if (typeof car.select === 'function') car.select(to); else sl[to].scrollIntoView({ block: 'nearest', inline: 'start' });
        });
        fig.appendChild(a);
      });
    });
  }
  function gallery(root) {
    if (!document.documentElement.classList.contains('v2-cardlook')) return; // cards are live's 1:1 (2026-10-15, asked); the v2 card extras sleep until html.v2-cardlook
    // the photo dots are part of the homepage card look only; every other page keeps the live card (2026-10-14)
    if (!document.documentElement.classList.contains('v2-home')) { cardArrows(root); return; }
    // the sale page's cards carry their own photo dots and swipe; a second set stacked two rows of dots on a tablet
    var cards = Array.prototype.slice.call((root || document).querySelectorAll('.product-card:not([data-v2-gal]):not([data-v2-arr]):not([data-v2-gal2])')).filter(function (c) { return !c.closest('.swb-sp__grid'); });
    var cache = new Map();
    var rowOf = cards.map(function (card) { return inRow(card, cache); }); // all reads first
    cards.forEach(function (card, ci) {
      var fig = card.querySelector('.product-card__figure');
      if (!fig) return;
      var car = fig.querySelector('product-card-carousel');
      var slides = car ? car.querySelectorAll('.product-card__carousel-slide') : [];
      var swap = fig.querySelector('.v2-swap--next');
      var n = slides.length > 1 ? slides.length : swap ? 2 : 0;
      /* a front photo plus a hover photo (the homepage rails: best sellers for your model, recommended): the second photo
         was only reachable by mouse hover, never on a phone. These cards get the two side arrows that flip between the two
         (cardArrows, below), except the first card of a row, the lifestyle "our choice" picture (2026-10-28, asked) */
      if (!n && fig.querySelector('.product-card__image--secondary')) {
        var rowEl = card.closest('.product-list, .newrow-carousel, [class*="carousel"]');
        if (rowEl && rowEl.querySelector('.product-card') === card) card.setAttribute('data-v2-arr', '');
        card.setAttribute('data-v2-gal2', '');
        return;
      }
      if (!n) { card.setAttribute('data-v2-gal', ''); return; } /* visited: a one-photo card is not re-measured on every change */
      card.setAttribute('data-v2-gal', '');
      card.setAttribute('data-v2-arr', ''); // one pair of arrows per card, never a second set from cardArrows() (2026-10-15)
      var at = 0;
      var dots = document.createElement('button');
      dots.type = 'button';
      dots.className = 'v2-dots';
      dots.setAttribute('aria-label', NEXT);
      /* a real control, not a strip of dots: arrows at both ends and a thumb-sized hit area. A tap on the left half
         goes back, anywhere else goes forward. It was 62x15px and a near miss opened the product instead. */
      var CH = function (d) { return '<b class="v2-dots__a v2-dots__a--' + (d < 0 ? 'p' : 'n') + '" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg></b>'; };
      dots.innerHTML = CH(-1) + '<span class="v2-dots__d">' + new Array(Math.min(n, 5) + 1).join('<i></i>') + '</span>' + CH(1);
      var paintDots = function () {
        if (slides.length > 1) {
          at = Array.prototype.findIndex.call(slides, function (s) { return s.classList.contains('is-active'); });
          if (at < 0) at = 0;
        }
        var on = n > 5 ? Math.round(at * 4 / (n - 1)) : at;
        dots.querySelectorAll('i').forEach(function (d, i) { d.classList.toggle('is-on', i === on); });
      };
      var go = function (dir) {
        if (slides.length > 1) {
          var b = car.querySelector(dir > 0 ? '[data-carousel-next]' : '[data-carousel-prev]');
          if (b) b.click();
        } else {
          swap.click();
          at = (at + 1) % 2;
        }
        paintDots();
      };
      dots.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var r = dots.getBoundingClientRect();
        go(ev.clientX && ev.clientX < r.left + r.width * 0.4 ? -1 : 1);
      });
      paintDots();
      fig.appendChild(dots);
      /* side arrows, as on the product page photos (2026-10-14, asked): previous on the left edge, next on the right,
         on every screen; the dots stay as the count of photos */
      [-1, 1].forEach(function (d) {
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'v2-garr v2-garr--' + (d < 0 ? 'p' : 'n');
        a.setAttribute('aria-label', d < 0 ? PREV : NEXT);
        a.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        a.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); go(d); });
        fig.appendChild(a);
      });
      if (rowOf[ci]) return;
      fig.classList.add('v2-swipe');
      var x0 = 0, y0 = 0, block = 0;
      fig.addEventListener('touchstart', function (ev) {
        x0 = ev.touches[0].clientX;
        y0 = ev.touches[0].clientY;
      }, { passive: true });
      fig.addEventListener('touchend', function (ev) {
        if (!touch.matches) return;
        var t = ev.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        go(dx < 0 ? 1 : -1);
        block = Date.now();
      }, { passive: true });
      // a swipe that ends on the picture is not a tap on the link (only a finger's click: go() itself clicks the
      // theme's hidden arrow, and stopping that click here is what kept the photo from changing)
      fig.addEventListener('click', function (ev) {
        if (ev.isTrusted && Date.now() - block < 450) { ev.preventDefault(); ev.stopPropagation(); }
      }, true);
    });
    cardArrows(root, '.product-card[data-v2-gal2]:not([data-v2-arr])'); /* the rail cards with a hover photo (above) */
  }
  function syncAll() {
    document.querySelectorAll('[data-v2-heart]').forEach(function (b) { paint(b, has(b.getAttribute('data-v2-heart'))); });
    var n = read().length;
    document.querySelectorAll('[data-v2-shortlist-count]').forEach(function (c) {
      c.textContent = String(n);
      c.hidden = !n;
    });
  }
  document.addEventListener(EVT, syncAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });

  var t = 0;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { decorate(document); gallery(document); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { decorate(document); gallery(document); syncAll(); });
  else { decorate(document); gallery(document); syncAll(); }

  window.swbShortlist = {
    get: function () { return read().map(function (x) { return x.h; }); },
    has: has,
    toggle: toggle,
    remove: remove,
    count: function () { return read().length; },
    onChange: function (fn) { document.addEventListener(EVT, function (e) { fn(e.detail); }); },
    event: EVT,
    itemEvent: ITEM_EVT
  };
  // the theme's add-to-cart contract, for the PDP set picker (sections/swb-v2-pdp-set.liquid) and any v2 section
  window.swbV2Cart = function (items) { return addToCart(items); };

  /* ==================================================================================================================
     THE PAGE (sections/swb-v2-shortlist.liquid renders the frame and the strings; this fills it)
     ================================================================================================================== */
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function money(c) {
    if (window.swbMoney) return window.swbMoney(c);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src, w) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }

  // the theme's own add-to-cart contract, so the drawer opens and repaints (Impact)
  function addToCart(items) {
    var r = root();
    var bundled = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: bundled } }));
    return fetch(r + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: bundled, sections_url: r + 'variants/' + items[0].id })
    })
      .then(function (res) { return res.json(); })
      .then(function (added) {
        return fetch(r + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            cart.sections = added.sections;
            var s = window.themeVariables && themeVariables.settings;
            if (s && s.cartType === 'page') { location.href = r + 'cart'; return cart; }
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            return cart;
          });
      });
  }

  function initPage() {
    var page = document.querySelector('[data-v2-slist]');
    if (!page || page.hasAttribute('data-ready')) return;
    page.setAttribute('data-ready', '');
    var S = JSON.parse(page.querySelector('[data-v2-slist-t]').textContent || '{}');
    var listEl = page.querySelector('[data-v2-slist-items]');
    var emptyEl = page.querySelector('[data-v2-slist-empty]');
    var barEl = page.querySelector('[data-v2-slist-bar]');
    var upEl = page.querySelector('[data-v2-slist-up]');
    var headEl = page.querySelector('[data-v2-slist-h]');
    var subEl = page.querySelector('[data-v2-slist-sub]');
    var saveAllEl = page.querySelector('[data-v2-slist-saveall]');
    var products = {};
    var chosen = {};

    /*
     * A SHARED LIST (?swb_list=a,b,c, the chat's share link) is shown as itself: "Gedeeld
     * lijstje", never written over the visitor's own list. "Bewaar in mijn lijst" adds the
     * missing ones to it. At most six handles, each checked; unknown ones are skipped.
     */
    var shared = (function () {
      var m = String(location.search).match(/[?&]swb_list=([^&#]+)/);
      if (!m) return null;
      var raw = '';
      try { raw = decodeURIComponent(m[1]); } catch (e) { return null; }
      var out = [];
      raw.split(',').forEach(function (x) {
        x = x.trim().toLowerCase();
        if (/^[a-z0-9][a-z0-9-]{1,120}$/.test(x) && out.indexOf(x) < 0 && out.length < 6) out.push(x);
      });
      return out.length ? out : null;
    })();
    page.classList.toggle('is-shared', !!shared);
    function handles() { return shared ? shared.slice() : window.swbShortlist.get().slice().reverse(); }

    function load(h) {
      if (products[h] !== undefined) return Promise.resolve(products[h]);
      return fetch(root() + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { products[h] = p && p.handle ? p : null; return products[h]; })
        ['catch'](function () { products[h] = null; return null; });
    }
    function variantOf(p) {
      var id = chosen[p.handle];
      var v = null;
      p.variants.forEach(function (x) { if (String(x.id) === String(id)) v = x; });
      if (!v && p.variants.length === 1) v = p.variants[0];
      return v;
    }
    var CART = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 10.2a1.5 1.5 0 0 0 1.5 1.1h7.9a1.5 1.5 0 0 0 1.4-1.1L20 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';
    /** One card in the chat's uniform shape: picture, price, a three line name, the size, two equal buttons. */
    function card(p) {
      var v = variantOf(p);
      var price = v ? v.price : p.price;
      var cmp = v ? v.compare_at_price : p.compare_at_price;
      var multi = p.variants.length > 1;
      var mine = window.swbShortlist.has(p.handle);
      var sel = multi
        ? '<select class="v2-sl__sel" data-h="' + esc(p.handle) + '" aria-label="' + esc(S.choose) + '"><option value="">' + esc(S.size || S.choose) + '</option>' +
          p.variants.map(function (x) {
            return '<option value="' + x.id + '"' + (v && v.id === x.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' (' + esc(S.soldout) + ')') + '</option>';
          }).join('') + '</select>'
        : '';
      var canAdd = p.available && (!v || v.available);
      return '<article class="v2-sl__card" data-h="' + esc(p.handle) + '">' +
        '<a class="v2-sl__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(p.featured_image, 400)) + '" alt="" loading="lazy" width="400" height="400"></a>' +
        '<p class="v2-sl__price"><b>' + esc(money(price)) + '</b>' + (cmp && cmp > price ? '<s>' + esc(money(cmp)) + '</s>' : '') + '</p>' +
        '<a class="v2-sl__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="v2-sl__opt">' + sel + '</div>' +
        '<div class="v2-sl__btns">' +
        '<button type="button" class="v2-sl__btn v2-sl__heart" data-heart="' + esc(p.handle) + '" aria-pressed="' + (mine ? 'true' : 'false') + '" aria-label="' + esc(mine ? S.remove : S.save) + '">' + HEART + '</button>' +
        '<button type="button" class="v2-sl__btn v2-sl__cart" data-add="' + esc(p.handle) + '"' + (canAdd ? '' : ' disabled') + ' aria-label="' + esc(p.available ? S.add : S.soldout) + '">' + CART + '</button>' +
        '</div></article>';
    }
    function nudge(n) {
      // the store's 2+1: every third strap is free
      var rest = n % 3;
      if (!n) return '';
      if (rest === 2) return S.deal1;
      if (rest === 0) return S.dealok;
      return S.deal2;
    }
    var shown = [];
    function render() {
      var hs = handles();
      if (headEl) headEl.textContent = (shared ? S.hShared : S.hOwn).replace('{n}', String(hs.length));
      if (subEl) subEl.textContent = shared ? S.subShared : S.subOwn;
      emptyEl.hidden = !!hs.length;
      barEl.hidden = !hs.length;
      page.classList.toggle('is-empty', !hs.length);
      if (!hs.length) { listEl.innerHTML = ''; if (upEl) upEl.hidden = true; return; }
      if (hs.some(function (h) { return products[h] === undefined; })) {
        listEl.innerHTML = hs.map(function () { return '<article class="v2-sl__card v2-sl__card--sk"><span class="v2-sl__media"></span><span></span><span></span></article>'; }).join('');
      }
      Promise.all(hs.map(load)).then(function (ps) {
        ps = ps.filter(Boolean);
        shown = ps;
        listEl.innerHTML = ps.map(card).join('');
        var n = ps.length;
        if (headEl) headEl.textContent = (shared ? S.hShared : S.hOwn).replace('{n}', String(n));
        barEl.querySelector('[data-v2-slist-n]').textContent = S.count.replace('%s', n);
        barEl.querySelector('[data-v2-slist-deal]').textContent = nudge(n);
        var total = 0;
        ps.forEach(function (p) { var v = variantOf(p); total += v ? v.price : p.price; });
        barEl.querySelector('[data-v2-slist-total]').textContent = money(total);
        if (saveAllEl) {
          var missing = ps.filter(function (p) { return !window.swbShortlist.has(p.handle); }).length;
          saveAllEl.hidden = !shared;
          saveAllEl.textContent = missing ? S.saveAll : S.savedAll;
          saveAllEl.disabled = !missing;
        }
        /* "Past goed bij je lijst" removed (2026-10-17, asked): the list is only what the visitor saved */
      });
    }
    function upsell(ps) {
      var first = ps[0];
      if (!first || upEl.hasAttribute('data-for') && upEl.getAttribute('data-for') === first.handle) return;
      upEl.setAttribute('data-for', first.handle);
      var saved = window.swbShortlist.get().concat(handles());
      var get = function (intent) {
        return fetch(root() + 'recommendations/products.json?product_id=' + first.id + '&limit=8&intent=' + intent)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) { return (d.products || []).filter(function (x) { return saved.indexOf(x.handle) < 0 && x.available; }); })
          ['catch'](function () { return []; });
      };
      get('complementary').then(function (list) { return list.length ? list : get('related'); }).then(function (list) {
        list = list.slice(0, 8);
        upEl.hidden = !list.length;
        upEl.querySelector('[data-v2-slist-uprow]').innerHTML = list.map(function (x) {
          var price = x.price, cmp = x.compare_at_price;
          return '<div class="v2-sl__up">' +
            '<a class="v2-sl__upimg" href="' + esc(x.url) + '"><img src="' + esc(img(x.featured_image, 300)) + '" alt="" loading="lazy" width="150" height="150"></a>' +
            '<a class="v2-sl__upt" href="' + esc(x.url) + '">' + esc(x.title) + '</a>' +
            '<p class="v2-sl__p"><b>' + esc(money(price)) + '</b>' + (cmp && cmp > price ? '<s>' + esc(money(cmp)) + '</s>' : '') + '</p>' +
            '<button type="button" class="v2-sl__upadd" data-save="' + esc(x.handle) + '">' + HEART + '<span>' + esc(S.save) + '</span></button>' +
            '</div>';
        }).join('');
      });
    }

    page.addEventListener('change', function (ev) {
      var s = ev.target.closest('.v2-sl__sel');
      if (!s) return;
      chosen[s.getAttribute('data-h')] = s.value;
      s.classList.remove('is-needed');
      render();
    });
    page.addEventListener('click', function (ev) {
      var ht = ev.target.closest('[data-heart]');
      if (ht) { window.swbShortlist.toggle(ht.getAttribute('data-heart')); return; }
      var sv = ev.target.closest('[data-save]');
      if (sv) { if (!window.swbShortlist.has(sv.getAttribute('data-save'))) window.swbShortlist.toggle(sv.getAttribute('data-save')); return; }
      if (ev.target.closest('[data-v2-slist-saveall]')) {
        // Added to the visitor's own list, never in place of it.
        shown.forEach(function (p) { if (!window.swbShortlist.has(p.handle)) window.swbShortlist.toggle(p.handle); });
        return;
      }
      if (ev.target.closest('[data-v2-slist-ask]')) {
        ev.preventDefault();
        var hs = shown.map(function (p) { return p.handle; });
        if (window.swbChatOpenList) window.swbChatOpenList(hs);
        return;
      }
      if (ev.target.closest('[data-v2-slist-find]')) {
        ev.preventDefault();
        var f = ev.target.closest('[data-v2-slist-find]');
        /* the chat that took this hand-off is not on the store: nothing listened and the button did nothing (2026-10-20
           sweep). With a saved watch it goes to that watch's straps; without one the header's watch picker opens. */
        if (window.swbChatOpenList) {
          document.dispatchEvent(new CustomEvent('swb-v2:chat-handoff', { detail: { text: f.getAttribute('data-say') || f.textContent.trim(), value: 'brands:all', origin: f } }));
          return;
        }
        var sw = null;
        try { sw = (window.swbV2 && window.swbV2.get && window.swbV2.get()) || JSON.parse(sessionStorage.getItem('swbV2Watch') || 'null'); } catch (e2) {}
        if (sw && sw.url) { location.href = sw.url; return; }
        var pill = document.querySelector('[data-v2-watch-open]');
        if (pill && pill.getClientRects().length) { pill.click(); return; }
        var tmp = document.createElement('a'); tmp.className = 'choose__watch'; tmp.href = '#'; tmp.hidden = true;
        document.body.appendChild(tmp); tmp.click(); tmp.remove();
        return;
      }
      var add = ev.target.closest('[data-add]');
      if (add) {
        var p = products[add.getAttribute('data-add')];
        var v = p && variantOf(p);
        if (!v) { var sel = add.closest('.v2-sl__card').querySelector('.v2-sl__sel'); if (sel) { sel.classList.add('is-needed'); sel.focus(); } return; }
        add.disabled = true;
        addToCart([{ id: v.id, quantity: 1 }]).then(function () {
          add.disabled = false;
          add.classList.add('is-done');
          setTimeout(function () { add.classList.remove('is-done'); }, 1800);
        })['catch'](function () { add.disabled = false; });
        return;
      }
      if (ev.target.closest('[data-v2-slist-all]')) {
        var items = [], missing = null;
        shown.forEach(function (pp) {
          if (!pp || !pp.available) return;
          var vv = variantOf(pp);
          if (vv && vv.available) items.push({ id: vv.id, quantity: 1 });
          else if (!missing) missing = pp.handle;
        });
        if (missing) {
          var sl = page.querySelector('.v2-sl__sel[data-h="' + missing + '"]');
          if (sl) { sl.scrollIntoView({ block: 'center', behavior: 'smooth' }); sl.classList.add('is-needed'); sl.focus(); }
          return;
        }
        if (items.length) addToCart(items);
      }
    });
    document.addEventListener(EVT, render);
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();

  /* ==================================================================================================================
     THE HEADER DROPDOWN (desktop): the heart opens a compact list under the island first; the full page is one
     click further. A phone goes straight to the page, where there is room for it.
     ================================================================================================================== */
  var P = {
    nl: ['Jouw lijst', 'Bekijk je lijst', 'Je lijst is nog leeg', 'Tik op het hartje bij een bandje om het te bewaren.', 'In winkelwagen', 'Kies een variant', 'Verwijderen', 'Toegevoegd'],
    de: ['Deine Liste', 'Liste ansehen', 'Deine Liste ist noch leer', 'Tippe auf das Herz bei einem Armband, um es zu speichern.', 'In den Warenkorb', 'Variante wählen', 'Entfernen', 'Hinzugefügt'],
    fr: ['Votre liste', 'Voir votre liste', 'Votre liste est encore vide', 'Touchez le cœur d\u2019un bracelet pour l\u2019enregistrer.', 'Ajouter au panier', 'Choisir une variante', 'Retirer', 'Ajouté'],
    es: ['Tu lista', 'Ver tu lista', 'Tu lista aún está vacía', 'Toca el corazón de una correa para guardarla.', 'Añadir al carrito', 'Elige una variante', 'Quitar', 'Añadido'],
    en: ['Your list', 'View your list', 'Your list is empty for now', 'Tap the heart on any strap to save it.', 'Add to cart', 'Choose an option', 'Remove', 'Added']
  }[lang] || null;
  if (!P) P = ['Your list', 'View your list', 'Your list is empty for now', 'Tap the heart on any strap to save it.', 'Add to cart', 'Choose an option', 'Remove', 'Added'];
  var popCache = {};
  function popLoad(h) {
    if (popCache[h]) return Promise.resolve(popCache[h]);
    return fetch(root() + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) popCache[h] = p; return p; })
      ['catch'](function () { return null; });
  }
  function initPop() {
    var btn = document.querySelector('[data-v2-slpop-open]');
    if (!btn || btn.hasAttribute('data-ready')) return;
    btn.setAttribute('data-ready', '');
    var hdr = btn.closest('.v2-hdr') || document.body;
    var pop = document.createElement('div');
    pop.className = 'v2-slpop';
    pop.hidden = true;
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-label', P[0]);
    hdr.appendChild(pop);
    var desk = window.matchMedia('(min-width: 990px)');
    function place() {
      var b = btn.getBoundingClientRect(), h = hdr.getBoundingClientRect();
      var isl = hdr.querySelector('.v2-hdr__island');
      var ib = isl ? isl.getBoundingClientRect() : b;
      pop.style.top = Math.round(ib.bottom - h.top + 8) + 'px';
      pop.style.right = Math.max(12, Math.round(h.right - b.right - 40)) + 'px';
    }
    function render() {
      var hs = window.swbShortlist.get().slice().reverse();
      /* a close button on every popover (2026-10-19, asked) */
      var XL = ({ nl: 'Sluiten', de: 'Schließen', fr: 'Fermer', es: 'Cerrar' })[String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase()] || 'Close';
      var head = '<div class="v2-slpop__head"><p class="v2-slpop__t">' + esc(P[0]) + (hs.length ? ' <span>' + hs.length + '</span>' : '') + '</p>' +
        '<button type="button" class="v2-slpop__x" data-slpop-x aria-label="' + XL + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></div>';
      if (!hs.length) {
        pop.innerHTML = head + '<div class="v2-slpop__empty"><p><b>' + esc(P[2]) + '</b></p><p>' + esc(P[3]) + '</p></div>';
        return;
      }
      pop.innerHTML = head + '<div class="v2-slpop__list">' + hs.slice(0, 6).map(function () { return '<div class="v2-slpop__row v2-slpop__row--sk"><span></span><span></span></div>'; }).join('') + '</div>' +
        '<a class="v2-btn v2-btn--accent v2-slpop__all" href="' + esc(btn.getAttribute('href')) + '">' + esc(P[1]) + '</a>';
      Promise.all(hs.slice(0, 6).map(popLoad)).then(function (ps) {
        var list = pop.querySelector('.v2-slpop__list');
        if (!list) return;
        list.innerHTML = ps.filter(Boolean).map(function (p) {
          var one = p.variants.length === 1;
          var v = one ? p.variants[0] : null;
          var price = v ? v.price : p.price, cmp = v ? v.compare_at_price : p.compare_at_price;
          return '<div class="v2-slpop__row" data-h="' + esc(p.handle) + '">' +
            '<a class="v2-slpop__img" href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 160)) + '" alt="" width="56" height="56"></a>' +
            '<div class="v2-slpop__info"><a class="v2-slpop__n" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<p class="v2-slpop__p"><b>' + esc(money(price)) + '</b>' + (cmp && cmp > price ? '<s>' + esc(money(cmp)) + '</s>' : '') + '</p></div>' +
            '<div class="v2-slpop__acts">' +
            (p.available ? (one
              ? '<button type="button" class="v2-slpop__add" data-add="' + v.id + '" aria-label="' + esc(P[4]) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>'
              : '<a class="v2-slpop__add" href="' + esc(p.url) + '" aria-label="' + esc(P[5]) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></a>') : '') +
            '<button type="button" class="v2-slpop__rm" data-rm="' + esc(p.handle) + '" aria-label="' + esc(P[6]) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
            '</div></div>';
        }).join('');
      });
    }
    function open() {
      /* the "saved to your list" notice says the same thing: it steps aside for the list itself (2026-10-19, asked) */
      var tst = document.querySelector('.v2-toast.is-on'); if (tst) tst.classList.remove('is-on');
      syncAll();
      render();
      place();
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (pop.hidden) return;
      pop.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!pop.classList.contains('is-open')) pop.hidden = true; }, 260);
    }
    btn.addEventListener('click', function (ev) {
      if (!desk.matches) return; // a phone goes to the page
      ev.preventDefault();
      if (pop.hidden) open(); else close();
    });
    pop.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-slpop-x]')) { close(); return; }
      var rm = ev.target.closest('[data-rm]');
      if (rm) { window.swbShortlist.remove(rm.getAttribute('data-rm')); return; }
      var add = ev.target.closest('button[data-add]');
      if (add) {
        add.disabled = true;
        addToCart([{ id: +add.getAttribute('data-add'), quantity: 1 }]).then(function () {
          close();
        })['catch'](function () { add.disabled = false; });
      }
    });
    document.addEventListener('click', function (ev) {
      if (pop.hidden || pop.contains(ev.target) || btn.contains(ev.target)) return;
      close();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') close(); });
    document.addEventListener(EVT, function () { if (!pop.hidden) render(); });
    window.addEventListener('resize', function () { if (!pop.hidden) place(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPop);
  else initPop();
  /* ==================================================================================================================
     THE LIST, BY EMAIL (Klaviyo, 2026-10-19, asked: "people can leave their email behind, then you know which straps
     they like and can send 'don't forget your favourites' or 'it is on sale now'").

     WHO IS ASKED. Every market loads the same Klaviyo account (USFLri, the Klaviyo app embed in settings_data.json),
     but that account mails the UK only: its live flow "Onderdrukken niet-UK en marketplace [EN]" suppresses every
     profile whose country is not United Kingdom OR is not set. Asking an NL/DE/FR/ES shopper for an address that is then
     suppressed would be a promise we cannot keep, so the ask (toast, sheet, page card) runs only where CAPTURE says so.
     Switching a market on later is one line here (and that market's own list and suppression rule in Klaviyo). The
     copy is already in all five languages.

     WHAT IS SENT.
       1. Hearts, for a visitor Klaviyo already knows (klaviyo.isIdentified()) and only with marketing consent from
          Shopify's cookie banner: "Added to Shortlist" / "Removed from Shortlist", properties named like Klaviyo's own
          Viewed Product (ProductID, ProductName, URL, ImageURL, Price, CompareAtPrice, Brand, Categories) plus the
          saved watch and $value. Every market, because the events cost nothing and say what people want.
       2. The form (explicit consent box, never pre-ticked; without it nothing is sent): a client subscription to the
          "Shortlist [EN]" list (double opt-in, so Klaviyo sends the confirmation mail), then ONE "Shortlist Saved"
          event carrying every saved strap in `items`, then klaviyo.identify() so later hearts are tracked too.
     No address is ever kept in this browser: localStorage only remembers that the ask was answered or waved away. */
  var KL = {
    key: 'USFLri',
    list: 'XAcDn7',
    revision: '2025-07-15',
    capture: { GB: 'United Kingdom' }, // market (Shopify.country) -> profile country; only these markets are asked
    source: 'Shortlist'
  };
  try { if (window.swbShortlistKlaviyo) for (var kk in window.swbShortlistKlaviyo) KL[kk] = window.swbShortlistKlaviyo[kk]; } catch (e) { /* ignore */ }
  var KL_FLAG = KEY + ':mail'; // 'sent' | 'no'
  var KL_SEEN = KEY + ':mailAsked'; // how often the toast asked
  var KL_HASH = '#swb-list-mail';
  var KT = ({
    nl: { ask: 'Ook per mail bewaren?', go: 'Mail mij', h: 'Bewaar je lijst per mail', sub: 'We sturen je je bewaarde bandjes en laten het weten als er een in de aanbieding gaat.', email: 'Je e-mailadres', consent: 'Ja, mail me over mijn favorieten en als ze in de aanbieding zijn', legal: 'Afmelden kan altijd, met één klik onderaan elke mail.', privacy: 'Privacybeleid', submit: 'Bewaar mijn lijst', badEmail: 'Vul een geldig e-mailadres in.', badConsent: 'Vink het vakje aan, dan mogen we je mailen.', doneH: 'Bijna klaar', done: 'Bevestig je aanmelding via de mail die we net stuurden. Daarna krijg je je lijst.', fail: 'Dat lukte niet. Probeer het zo nog eens.', close: 'Sluiten' },
    de: { ask: 'Auch per Mail sichern?', go: 'Per Mail', h: 'Speichere deine Liste per Mail', sub: 'Wir schicken dir deine gemerkten Armbänder und sagen Bescheid, wenn eins im Angebot ist.', email: 'Deine E-Mail-Adresse', consent: 'Ja, schickt mir Mails zu meinen Favoriten und wenn sie im Angebot sind', legal: 'Abmelden jederzeit mit einem Klick in jeder Mail.', privacy: 'Datenschutz', submit: 'Liste speichern', badEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.', badConsent: 'Setz das Häkchen, dann dürfen wir dir schreiben.', doneH: 'Fast geschafft', done: 'Bestätige deine Anmeldung über die Mail, die wir gerade geschickt haben. Danach bekommst du deine Liste.', fail: 'Das hat nicht geklappt. Versuch es gleich noch einmal.', close: 'Schließen' },
    fr: { ask: 'Recevoir votre liste par e-mail ?', go: 'Par e-mail', h: 'Recevez votre liste par e-mail', sub: 'Nous vous envoyons vos bracelets enregistrés et vous prévenons dès que l’un d’eux est en promotion.', email: 'Votre adresse e-mail', consent: 'Oui, envoyez-moi des e-mails sur mes favoris et quand ils sont en promotion', legal: 'Désinscription possible à tout moment, en un clic dans chaque e-mail.', privacy: 'Confidentialité', submit: 'Enregistrer ma liste', badEmail: 'Saisissez une adresse e-mail valide.', badConsent: 'Cochez la case pour que nous puissions vous écrire.', doneH: 'Presque terminé', done: 'Confirmez votre inscription via l’e-mail que nous venons d’envoyer. Vous recevrez ensuite votre liste.', fail: 'Cela n’a pas fonctionné. Réessayez dans un instant.', close: 'Fermer' },
    es: { ask: '¿Te la enviamos por correo?', go: 'Por correo', h: 'Guarda tu lista por correo', sub: 'Te enviamos tus correas guardadas y te avisamos cuando alguna esté en oferta.', email: 'Tu correo electrónico', consent: 'Sí, enviadme correos sobre mis favoritos y cuando estén en oferta', legal: 'Puedes darte de baja cuando quieras, con un clic en cada correo.', privacy: 'Privacidad', submit: 'Guardar mi lista', badEmail: 'Escribe un correo electrónico válido.', badConsent: 'Marca la casilla para que podamos escribirte.', doneH: 'Casi listo', done: 'Confirma tu suscripción en el correo que te acabamos de enviar. Después recibirás tu lista.', fail: 'No ha funcionado. Inténtalo de nuevo en un momento.', close: 'Cerrar' },
    en: { ask: 'Want it by email too?', go: 'Email me', h: 'Save your list by email', sub: 'We will send you your saved straps and let you know when one goes on sale.', email: 'Your email address', consent: 'Yes, email me about my favourites and when they are on sale', legal: 'Unsubscribe any time, with one click at the bottom of every email.', privacy: 'Privacy policy', submit: 'Save my list', badEmail: 'Please enter a valid email address.', badConsent: 'Tick the box so we are allowed to email you.', doneH: 'Almost done', done: 'Confirm your sign-up in the email we just sent. Your list follows after that.', fail: 'That did not work. Please try again in a moment.', close: 'Close' }
  })[lang] || null;
  if (!KT) KT = { ask: 'Want it by email too?', go: 'Email me', h: 'Save your list by email', sub: 'We will send you your saved straps and let you know when one goes on sale.', email: 'Your email address', consent: 'Yes, email me about my favourites and when they are on sale', legal: 'Unsubscribe any time, with one click at the bottom of every email.', privacy: 'Privacy policy', submit: 'Save my list', badEmail: 'Please enter a valid email address.', badConsent: 'Tick the box so we are allowed to email you.', doneH: 'Almost done', done: 'Confirm your sign-up in the email we just sent. Your list follows after that.', fail: 'That did not work. Please try again in a moment.', close: 'Close' };

  function klMarket() { return String((window.Shopify && Shopify.country) || '').toUpperCase(); }
  function klCanAsk() { return !!KL.capture[klMarket()]; }
  function klGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function klSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  /* Shopify's cookie banner decides whether behaviour may be tied to a person. No banner API (a region without one):
     the Klaviyo embed itself is the store's choice, so it is allowed. */
  function klMarketingOk() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed();
    } catch (e) { /* ignore */ }
    return true;
  }
  function klOnsite() { var k = window.klaviyo; return k && typeof k.track === 'function' ? k : null; }
  function klIdentified() {
    var k = klOnsite();
    if (!k || typeof k.isIdentified !== 'function') return Promise.resolve(false);
    try { return Promise.resolve(k.isIdentified()).then(function (v) { return !!v; }, function () { return false; }); } catch (e) { return Promise.resolve(false); }
  }
  function klWatch() {
    var w = null;
    try { w = window.swbV2 && typeof window.swbV2.get === 'function' ? window.swbV2.get() : null; } catch (e) { w = null; }
    if (!w) { try { w = JSON.parse(sessionStorage.getItem('swbV2Watch') || 'null'); } catch (e) { w = null; } }
    if (!w) {
      var hd = document.querySelector('[data-v2-watch][data-saved-model]');
      if (hd) w = { brand: hd.getAttribute('data-saved-brand') || '', model: hd.getAttribute('data-saved-model') || '' };
    }
    return w && (w.model || w.brand) ? w : null;
  }
  var klCache = {};
  function klProduct(h) {
    if (klCache[h]) return klCache[h];
    klCache[h] = fetch(root() + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })['catch'](function () { return null; });
    return klCache[h];
  }
  /* One strap in the shape Klaviyo's catalog and its Viewed Product events use, so a flow can show it with the same
     blocks. Prices are in the shopper's currency, as the storefront showed them. */
  function klItem(p) {
    var price = p.price / 100;
    var cmp = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price / 100 : null;
    var im = p.featured_image || '';
    if (im.indexOf('//') === 0) im = 'https:' + im;
    return {
      ProductID: String(p.id),
      ProductName: p.title,
      ProductHandle: p.handle,
      URL: location.origin + (p.url || '/products/' + p.handle),
      ImageURL: im,
      Price: price,
      CompareAtPrice: cmp,
      OnSale: !!cmp,
      Available: !!p.available,
      Brand: p.vendor || '',
      Vendor: p.vendor || '',
      Categories: [p.type].filter(Boolean),
      Currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || ''
    };
  }
  function klContext() {
    var w = klWatch();
    return { Market: klMarket(), Language: lang, WatchBrand: w ? w.brand || '' : '', WatchModel: w ? w.model || '' : '' };
  }
  function klListUrl(handles) {
    var a = document.querySelector('a[href*="shortlist"], a[href*="mijn-lijst"]');
    var base = a ? a.getAttribute('href') : '/pages/shortlist';
    if (base.indexOf('http') !== 0) base = location.origin + base;
    base = base.split('?')[0];
    // the shared-list link (at most six straps, see initPage) opens the same list on any device, a phone from a mail too
    return { own: base, shared: handles.length ? base + '?swb_list=' + handles.slice(0, 6).map(encodeURIComponent).join(',') : base };
  }

  // 1. hearts from a visitor Klaviyo knows
  document.addEventListener(ITEM_EVT, function (ev) {
    var d = ev.detail || {};
    if (!d.handle || !klOnsite() || !klMarketingOk()) return;
    klIdentified().then(function (known) {
      if (!known) return null;
      return klProduct(d.handle).then(function (p) {
        if (!p) return;
        var props = klItem(p), ctx = klContext();
        for (var c in ctx) props[c] = ctx[c];
        props.ListCount = d.count;
        props.$value = props.Price;
        try { klOnsite().track(d.on ? 'Added to Shortlist' : 'Removed from Shortlist', props); } catch (e) { /* never break a heart */ }
      });
    })['catch'](function () { /* ignore */ });
  });

  // 2. the ask: one line in the "saved" toast from the second heart on, at most twice, never after an answer
  document.addEventListener(ITEM_EVT, function (ev) {
    var d = ev.detail || {};
    if (!d.on || d.count < 2 || !klCanAsk() || klGet(KL_FLAG) || !window.swbV2Toast) return;
    if (document.querySelector('[data-v2-slist]')) return; // the list page carries its own card
    var seen = +(klGet(KL_SEEN) || 0);
    if (seen >= 2 || (seen === 1 && d.count < 4)) return;
    klIdentified().then(function (known) {
      if (known) return; // Klaviyo already knows them: their hearts reach the flows without asking
      // after this click's own "saved" toast, so the ask replaces it rather than being replaced by it
      setTimeout(function () {
        var ti = document.querySelector('.v2-toast .v2-toast__img:not([hidden])');
        var src = ti ? String(ti.getAttribute('src') || '').split('?')[0] : '';
        window.swbV2Toast(KT.ask, src, { msg: SAVED_T[lang] ? SAVED_T[lang][0] : SAVED_T.en[0], go: KT.go, href: KL_HASH });
        klSet(KL_SEEN, String(seen + 1));
      }, 60);
    });
  });
  // the toast close button while it shows OUR ask means 'no thanks': never asked again
  document.addEventListener('click', function (ev) {
    var x = ev.target.closest && ev.target.closest('[data-v2-toast-x]');
    var item = x && x.closest('.v2-toast') && x.closest('.v2-toast').querySelector('[data-v2-toast-item]');
    if (item && item.textContent === KT.ask) klSet(KL_FLAG, 'no');
  }, true);

  // 3. the form, as a sheet (from the toast, or any link to #swb-list-mail) and as a card on the list page
  var KL_CSS = '' +
    '.swb-klm{display:grid;gap:12px;font:inherit;color:rgb(20 20 20)}' +
    '.swb-klm__h{margin:0;font-size:1.125rem;font-weight:800;line-height:1.25}' +
    '.swb-klm__s{margin:0;font-size:.875rem;line-height:1.45;color:rgb(20 20 20/.72)}' +
    '.swb-klm__f{display:grid;gap:10px}' +
    '.swb-klm__in{width:100%;min-height:48px;padding:0 14px;border:1.5px solid rgb(20 20 20/.18);border-radius:12px;background:#fff;font:inherit;font-size:16px;color:inherit;box-sizing:border-box}' +
    '.swb-klm__in:focus{outline:none;border-color:rgb(20 20 20)}' +
    '.swb-klm__c{display:grid;grid-template-columns:22px minmax(0,1fr);gap:10px;align-items:start;font-size:.875rem;line-height:1.4;cursor:pointer}' +
    '.swb-klm__c input{width:20px;height:20px;margin:1px 0 0;accent-color:rgb(255 79 1);cursor:pointer}' +
    '.swb-klm .swb-klm__b{display:flex;align-items:center;justify-content:center;width:100%;padding:0 20px;text-align:center;min-height:48px;border:0;border-radius:999px;background:rgb(255 79 1);color:#fff;font:inherit;font-size:.9375rem;font-weight:800;cursor:pointer}' +
    '.swb-klm__b[disabled]{opacity:.6;cursor:default}' +
    '.swb-klm__e{margin:0;font-size:.8125rem;font-weight:700;color:rgb(185 28 28)}.swb-klm__e:empty{display:none}' +
    '.swb-klm__l{margin:0;font-size:.75rem;line-height:1.4;color:rgb(20 20 20/.6)}.swb-klm__l a{color:inherit;text-decoration:underline}' +
    '.swb-klm__ok{display:grid;gap:6px}.swb-klm__ok[hidden],.swb-klm__f[hidden],.swb-klm[hidden]{display:none}' +
    '.swb-klm__okh{margin:0;font-weight:800;display:flex;align-items:center;gap:8px}' +
    '.swb-klm__okh::before{content:"";width:20px;height:20px;border-radius:50%;flex:none;background:rgb(22 163 74) url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%273.4%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M5.5 12.5l4 4 9-9%27/%3E%3C/svg%3E") center/12px no-repeat}' +
    '.swb-klm__okp{margin:0;font-size:.875rem;line-height:1.45;color:rgb(20 20 20/.72)}' +
    '.v2-sl__mail{max-width:560px;margin:28px 0 0;padding:20px 16px;border-radius:20px;background:rgb(20 20 20/.04);box-sizing:border-box}.v2-sl.is-empty .v2-sl__mail,.v2-sl.is-shared .v2-sl__mail{display:none}@media (min-width:990px){.v2-sl__mail{padding:24px}}' +
    '.swb-kls{position:fixed;inset:0;z-index:10090;display:grid;align-items:end;justify-items:center;background:rgb(0 0 0/.42);opacity:0;transition:opacity .2s ease}' +
    '.swb-kls[hidden]{display:none}.swb-kls.is-on{opacity:1}' +
    '.swb-kls__p{position:relative;width:100%;max-width:440px;max-height:calc(100dvh - 24px);overflow:auto;box-sizing:border-box;padding:22px 16px calc(18px + env(safe-area-inset-bottom,0px));border-radius:22px 22px 0 0;background:#fff;box-shadow:0 -12px 40px -12px rgb(0 0 0/.35);transform:translateY(24px);transition:transform .3s cubic-bezier(.32,.72,0,1)}' +
    '.swb-kls.is-on .swb-kls__p{transform:none}' +
    '.swb-kls__x{position:absolute;top:10px;right:10px;width:40px;height:40px;display:grid;place-items:center;border:0;border-radius:50%;background:rgb(20 20 20/.06);color:inherit;cursor:pointer}' +
    '.swb-kls .swb-klm__h{padding-right:44px}' +
    '@media (min-width:750px){.swb-kls{align-items:center}.swb-kls__p{padding:26px 24px 22px;border-radius:22px;transform:translateY(12px)}}';
  function klStyle() {
    if (document.getElementById('swb-klm-css')) return;
    var s = document.createElement('style');
    s.id = 'swb-klm-css';
    s.textContent = KL_CSS;
    document.head.appendChild(s);
  }
  var klUid = 0;
  function klForm(cls) {
    klStyle();
    var id = 'swb-klm-' + (++klUid);
    var el = document.createElement('div');
    el.className = 'swb-klm ' + (cls || '');
    el.innerHTML =
      '<p class="swb-klm__h" id="' + id + '-h">' + esc(KT.h) + '</p>' +
      '<p class="swb-klm__s">' + esc(KT.sub) + '</p>' +
      '<form class="swb-klm__f" novalidate>' +
      '<label class="v2-sr" for="' + id + '-e" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">' + esc(KT.email) + '</label>' +
      '<input class="swb-klm__in" id="' + id + '-e" type="email" name="email" autocomplete="email" inputmode="email" required placeholder="' + esc(KT.email) + '">' +
      '<label class="swb-klm__c"><input type="checkbox" name="consent"><span>' + esc(KT.consent) + '</span></label>' +
      '<p class="swb-klm__e" role="alert"></p>' +
      '<button type="submit" class="swb-klm__b">' + esc(KT.submit) + '</button>' +
      '<p class="swb-klm__l">' + esc(KT.legal) + ' <a href="' + esc(root() + 'policies/privacy-policy') + '" target="_blank" rel="noopener">' + esc(KT.privacy) + '</a></p>' +
      '</form>' +
      '<div class="swb-klm__ok" role="status" hidden><p class="swb-klm__okh">' + esc(KT.doneH) + '</p><p class="swb-klm__okp">' + esc(KT.done) + '</p></div>';
    var f = el.querySelector('form'), err = el.querySelector('.swb-klm__e'), btn = el.querySelector('.swb-klm__b');
    function done() { f.hidden = true; el.querySelector('.swb-klm__ok').hidden = false; }
    if (klGet(KL_FLAG) === 'sent') done();
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(f.email.value || '').trim();
      err.textContent = '';
      if (!/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(email)) { err.textContent = KT.badEmail; f.email.focus(); return; }
      if (!f.consent.checked) { err.textContent = KT.badConsent; f.consent.focus(); return; }
      btn.disabled = true;
      klSubmit(email).then(function () {
        klSet(KL_FLAG, 'sent');
        document.querySelectorAll('.swb-klm').forEach(function (m) { var ff = m.querySelector('form'); if (ff) ff.hidden = true; var ok = m.querySelector('.swb-klm__ok'); if (ok) ok.hidden = false; });
      }, function () {
        err.textContent = KT.fail;
        btn.disabled = false;
      });
    });
    return el;
  }
  function klPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: KL.revision },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); return r; });
  }
  function klSubmit(email) {
    var handles = window.swbShortlist.get().slice().reverse().slice(0, 20); // newest first
    var country = KL.capture[klMarket()];
    var attrs = {
      email: email,
      properties: { 'Shortlist Market': klMarket(), 'Shortlist Language': lang },
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (country) attrs.location = { country: country };
    return klPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { custom_source: KL.source, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: KL.list } } }
      }
    }).then(function () {
      return Promise.all(handles.map(klProduct));
    }).then(function (ps) {
      var items = ps.filter(Boolean).map(klItem);
      var total = 0;
      items.forEach(function (x) { total += x.Price; });
      var links = klListUrl(items.map(function (x) { return x.ProductHandle; }));
      var props = klContext();
      props.items = items;
      props.ItemNames = items.map(function (x) { return x.ProductName; });
      props.ItemCount = items.length;
      props.OnSaleCount = items.filter(function (x) { return x.OnSale; }).length;
      props.ListURL = links.own;
      props.SharedListURL = links.shared;
      props.Currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
      props.$value = Math.round(total * 100) / 100;
      // the subscription is what counts; a lost event must not turn a sign-up into an error message
      return klPost('events', {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            value: props.$value,
            metric: { data: { type: 'metric', attributes: { name: 'Shortlist Saved' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      })['catch'](function () { return null; });
    }).then(function () {
      // from now on this browser's hearts reach Klaviyo as well (only with the banner's marketing consent)
      var k = klOnsite();
      if (k && typeof k.identify === 'function' && klMarketingOk()) { try { k.identify({ email: email }); } catch (e) { /* ignore */ } }
    });
  }

  var klSheet = null, klBack = null;
  function klOpen() {
    if (!klCanAsk()) return;
    klStyle();
    if (!klSheet) {
      klSheet = document.createElement('div');
      klSheet.className = 'swb-kls';
      klSheet.hidden = true;
      klSheet.setAttribute('data-v2-own-layer', '');
      var p = document.createElement('div');
      p.className = 'swb-kls__p';
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-modal', 'true');
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'swb-kls__x';
      x.setAttribute('aria-label', KT.close);
      x.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      var form = klForm();
      p.setAttribute('aria-labelledby', form.querySelector('.swb-klm__h').id);
      p.appendChild(x);
      p.appendChild(form);
      klSheet.appendChild(p);
      document.body.appendChild(klSheet);
      x.addEventListener('click', klClose);
      klSheet.addEventListener('click', function (ev) { if (ev.target === klSheet) klClose(); });
      document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && klSheet && !klSheet.hidden) klClose(); });
    }
    klBack = document.activeElement;
    klSheet.hidden = false;
    requestAnimationFrame(function () {
      klSheet.classList.add('is-on');
      var inp = klSheet.querySelector('.swb-klm__in');
      if (inp && !klSheet.querySelector('form').hidden) { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }
    });
  }
  function klClose() {
    if (!klSheet || klSheet.hidden) return;
    klSheet.classList.remove('is-on');
    setTimeout(function () { if (!klSheet.classList.contains('is-on')) klSheet.hidden = true; }, 220);
    if (klBack && klBack.focus) { try { klBack.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }
  function klHash() {
    if (location.hash !== KL_HASH) return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* ignore */ }
    klOpen();
  }
  window.addEventListener('hashchange', klHash);
  // bfcache: a page restored from history must not come back with the sheet frozen half open
  window.addEventListener('pageshow', function (e) { if (e.persisted && klSheet && !klSheet.classList.contains('is-on')) klSheet.hidden = true; });
  function klPage() {
    var mount = document.querySelector('[data-v2-slist-mail]');
    if (mount && klCanAsk() && !mount.firstChild) { mount.appendChild(klForm()); mount.hidden = false; }
    klHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', klPage);
  else klPage();
  window.swbShortlistMail = { open: klOpen, config: KL };

})();
